import { useSelector } from "react-redux";
import { RootState } from "../state/reducers";

export default function useCurrentRole() {
  return useSelector(
    (state: RootState) => state.currentUser.currentUser?.role || ""
  );
}
